import { isEnabled } from "lib/@components/feature"
import { registerFeatureWithDescription } from "lib/features"
import { Lazy } from "lib/make-lazy"
import { registerSystemAdminTab } from "routes/sfg20-admin/plugins/system-tab/register-system-admin-tab"
import { FEATURE_FLAG_TREE_REPAIR } from "./server/feature-flag-tree-repair.mjs"
import { PRIORITY_DATA, SECTION_DATA } from "routes/sfg20-admin/plugins/system-tab/system-admin-sections"

registerFeatureWithDescription({
    numericalId: 5003,
    id: FEATURE_FLAG_TREE_REPAIR,
    name: "Tree Repair",
    descriptionLines: [
        "Identifies empty base regime trees with a valid plan-history backup.",
        "Allows an administrator to back up and restore one damaged tree at a time.",
    ],
    internalUseOnly: true,
})

registerSystemAdminTab(
    "Tree Repair",
    <Lazy importer={() => import("./tree-repair")} extract="TreeRepair" />,
    () => isEnabled(FEATURE_FLAG_TREE_REPAIR),
    PRIORITY_DATA + 10,
    undefined,
    SECTION_DATA
)
